<form [formGroup]="objFormGroup">    
<h3 mat-dialog-title>{{title}}</h3>
<div mat-dialog-content>
    <div class="grid-container" [class.hideField]="isLoading" > <!-- style="overflow:auto; height:400px;"-->
        <div class="object-config">
            <mat-card  appearance="outlined">
                <mat-card-title class="card-title">Object Settings</mat-card-title>

                <div class="two-column-config">
                    <div class="config-column1">
                        <mat-form-field>
                            <mat-label>Site</mat-label>
                            <mat-select formControlName="PlantName" (selectionChange)="selectPlant()">
                            <mat-option *ngFor="let d of plantList" [value]="d.display_name">{{d.display_name}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field [class.hideField]="lineOverride" style="margin-bottom: -.75em;">
                            <mat-label>Line</mat-label>
                            <mat-select formControlName="line" (selectionChange)="selectLine()" cdkFocusInitial>
                                <mat-option *ngFor="let d of lineListFiltered" [value]="d.line_id">{{d.line}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field [class.hideField]="lineOverride" style="margin-bottom: -1.25em;">
                            <mat-label>Sub Line</mat-label>
                            <mat-select formControlName="subline" (selectionChange)="selectSubLine()" cdkFocusInitial>
                                <mat-option *ngFor="let d of subLineListFiltered" [value]="d.subline_id">{{d.subline}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <!-- REMOVE AS PART OF ITMFG-45218-->
                        <mat-form-field [class.hideField]="!lineOverride">
                            <mat-label>Section</mat-label>
                            <textarea matInput cdkTextareaAutosize placeholder="Section" formControlName="Section"></textarea>
                        </mat-form-field>

                        <mat-form-field [class.hideField]="!lineOverride" style="margin-bottom: -1.25em;">
                            <mat-label>Sub Section</mat-label>
                            <textarea matInput cdkTextareaAutosize placeholder="Sub Section" formControlName="SubSection"></textarea>
                        </mat-form-field>

                        <div style="margin-top: 0px; ">
                            <mat-checkbox class="example-margin" style="font-size: 10px;" formControlName="line_override" (change)="selectOverride()" labelPosition="after"><span  style="font-size: 10px;">Override Standardized Work Line and Sub Line</span></mat-checkbox>
                        </div>
                        <!-- END REMOVE-->
                    </div>
                    <div class="config-column2">
                        <mat-form-field>
                            <mat-label>Type</mat-label>
                            <mat-select formControlName="ObjectType">
                                <mat-option value="GROUP">Assembly Group</mat-option>
                                <mat-option value="ASSEMBLY">Assembly</mat-option>
                                <mat-option value="FAB">Fab</mat-option>
                            </mat-select>
                        </mat-form-field> 

                        <mat-form-field>
                            <mat-label>Object ID</mat-label>
                            <textarea matInput cdkTextareaAutosize placeholder="Object ID" formControlName="ObjectID"></textarea>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>EAM Asset</mat-label>
                            <textarea matInput cdkTextareaAutosize placeholder="EAMAsset" formControlName="EAMAsset"></textarea>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Description</mat-label>
                            <textarea matInput cdkTextareaAutosize placeholder="Description" formControlName="Description"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </mat-card>
        </div>
        <div class="data-collection">
            <mat-card  appearance="outlined">
                <mat-card-title class="card-title">Data Collection Settings</mat-card-title>
                <div class="two-column-config">
                    <div class="config-column1">
                        <mat-form-field style="width: 250px;">
                            <mat-label>Count Collection</mat-label>
                            <mat-select formControlName="ManCount" (selectionChange)="onChangeCountCollection()" panelWidth="275px">
                            <mat-option [value]="0">Automatic</mat-option>
                            <mat-option [value]="1">Manual</mat-option>
                            <mat-option [value]="2">Alternative Count Object</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field *ngIf="showCountObjectID">
                            <mat-label>Count Object ID</mat-label>
                            <textarea matInput cdkTextareaAutosize placeholder="Count Object ID" formControlName="CountObjectID"></textarea>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Problem Collection</mat-label>
                            <mat-select formControlName="ManProb">
                            <mat-option [value]="0">Automatic</mat-option>
                            <mat-option [value]="1">Manual</mat-option>
                            <mat-option [value]="2">Auto and Manual</mat-option>
                            </mat-select>
                        </mat-form-field>            


                    </div>
                    <div class="config-column2">

        
                        <mat-form-field>
                            <mat-label>Exclude Timer Group(s) (optional)</mat-label>
                            <mat-select multiple formControlName="ExcludeTimerGroups" cdkFocusInitial>
                            <mat-option *ngFor="let d of timerGroups" [value]="d">{{d}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div>
                        
                        <mat-form-field [style.width.px]="250">
                            <mat-hint align="end">Hint</mat-hint>
                            <mat-label >Ignore Faults Less Than (Seconds)</mat-label>
                            <input matInput cdkTextareaAutosize type="number" size="1" min="0" formControlName="IgnoreSeconds">
                             
                        </mat-form-field>
                        </div>
                        
                    </div>
                </div>

            </mat-card>
        </div>
        <div class="root-cause">
            <mat-card  appearance="outlined">
                <mat-card-title class="card-title">Root Cause Settings</mat-card-title>
                <div class="two-column-config">
                    <div class="config-column1">
                        <mat-form-field>
                            <mat-label>Require Note</mat-label>
                            <mat-select formControlName="ProbNoteReq">
                            <mat-option [value]="0">Optional</mat-option>
                            <mat-option [value]="1">Required</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Minimum Required Level</mat-label>
                            <mat-select  formControlName="ProbLevelReq">
                            <mat-option [value]="0">0</mat-option>
                            <mat-option [value]="1">1</mat-option>
                            <mat-option [value]="2">2</mat-option>
                            <mat-option [value]="3">3</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Team Group (optional)</mat-label>
                            <mat-select formControlName="TeamGroup" cdkFocusInitial>
                            <mat-option *ngFor="let d of teamGroups" [value]="d.TeamGroup">{{d.Description}}</mat-option>
                            </mat-select>
                        </mat-form-field>


                    </div>
                    <div class="config-column2">

                        <div>
                            <mat-checkbox formControlName="SharedProblemGroup" (change)="selectSharedProblemGroup()" labelPosition="after">Use Shared Problem Group</mat-checkbox>
                        </div>
                        <mat-form-field [class.hideField]="!sharedProblemGroup" style="min-width: 250px;">
                            <mat-label>Shared Problem Group</mat-label>
                            <mat-select formControlName="ProblemGroup" cdkFocusInitial panelClass="custom-size-select-panel-350px custom-size-select-panel">
                            <mat-option *ngFor="let d of problemGroups" [value]="d.ProblemGroup">{{d.Description}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>            
</div>   
<div mat-dialog-actions>
    <button mat-raised-button (click)="saveData()" [disabled]="objFormGroup.invalid || isSaving">Save</button>
    <button mat-raised-button (click)="onNoClick()">Cancel</button>
</div>
</form>

<div *ngIf="isSaving || isLoading">
    <mat-spinner></mat-spinner>
</div>